import styled from "styled-components"
import { rem } from "@mantine/core"

export const InputWrapper = styled.div<{ position: "left" | "right" }>`
    position: relative;
    display: inline-block;
    width: 100%;

    & > input {
        ${(props) => (props.position === "left" ? `padding-left: ${rem(30)};` : `padding-right: ${rem(30)};`)}
    }
`

export const IconWrapper = styled.div<{ position: "left" | "right" }>`
    position: absolute;
    ${(props) => (props.position === "left" ? `left: ${rem(12)};` : `right: ${rem(12)};`)}
    top: 50%;
    transform: translateY(-50%);
    color: #666;

    z-index: 1;
`
